export const fallbackStates = ['WI', 'CA', 'TX', 'FL'];

export const toArray = (response) => {
  if (Array.isArray(response)) return response;
  if (Array.isArray(response?.data)) return response.data;
  if (Array.isArray(response?.Data)) return response.Data;
  if (Array.isArray(response?.items)) return response.items;
  return [];
};

export const getSortValue = (row, field) => {
  const value = field.split('.').reduce((accumulator, key) => accumulator?.[key], row);
  return value ?? '';
};

export const compareRows = (left, right, field, direction) => {
  const leftValue = getSortValue(left, field);
  const rightValue = getSortValue(right, field);

  if (leftValue < rightValue) return direction === 'asc' ? -1 : 1;
  if (leftValue > rightValue) return direction === 'asc' ? 1 : -1;
  return 0;
};

export const getSortLabel = (activeField, activeDirection, field) => {
  if (activeField !== field) return 'Sort';
  return activeDirection === 'asc' ? 'Ascending' : 'Descending';
};

export const getPagedRows = (rows, currentPage, rowsPerPage) =>
  rows.slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage);

export const getPageSummary = (totalRows, currentPage, rowsPerPage) => ({
  firstRecord: totalRows === 0 ? 0 : (currentPage - 1) * rowsPerPage + 1,
  lastRecord: Math.min(currentPage * rowsPerPage, totalRows),
  totalPages: Math.max(1, Math.ceil(totalRows / rowsPerPage)),
});

export const normalizeLookupName = (item) => item?.name ?? item?.Name ?? item?.description ?? item?.Description ?? '';

export const getStatusLabel = (statusId) => {
  const fallbackStatusOptions = [
    { label: 'Draft', value: 139 },
    { label: 'ProposalCreated', value: 137 },
    { label: 'Approved', value: 140 },
    { label: 'Sold', value: 3 },
  ];
  return fallbackStatusOptions.find((option) => option.value === Number(statusId))?.label || `Status ${statusId || '-'}`;
};

export const formatSalesDate = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  if (Number.isNaN(date.getTime())) return '';
  return date.toLocaleString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
};

export const formatSalesCurrency = (amount) =>
  new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(Number(amount) || 0);
